import { useTranslation } from "react-i18next";

import H1 from "@/components/H1";
import P from "@/components/P";
import Spacer from "@/components/Spacer";

function SignUpMessage() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center p-4 text-center min-h-screen-minus-footer">
          <H1>
            {t("auth:verify-email-header")}
          </H1>
          <div className="w-full text-white lg:w-2/3">
            <Spacer />
            <P>{t("auth:verify-email-text")}</P>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SignUpMessage;
